const MAIN_URL = 'https://george-fx.github.io/apitex_api/';

export const GET_USERS = `${MAIN_URL}api/users.json`;
export const GET_TRANSACTIONS = `${MAIN_URL}api/transactions.json`;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const URLS = {
  GET_USERS,
  GET_TRANSACTIONS,
  API_BASE_URL,
};
